// Countdown Timer JavaScript
document.addEventListener('DOMContentLoaded', function() {
  const countdownTimer = document.querySelector('.countdown-timer');
  
  if (!countdownTimer) return;
  
  const endDate = countdownTimer.getAttribute('data-end-date');
  const endTime = new Date(endDate).getTime();
  
  function updateCountdown() {
    const now = new Date().getTime();
    const distance = endTime - now;
    
    if (distance < 0) {
      // Countdown is finished - hide the entire countdown section
      const countdownSection = document.querySelector('.countdown-section');
      if (countdownSection) {
        countdownSection.style.display = 'none';
      }
      return;
    }
    
    // Calculate time units
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    // Update display
    document.getElementById('countdown-days').textContent = days.toString().padStart(2, '0');
    document.getElementById('countdown-hours').textContent = hours.toString().padStart(2, '0');
    document.getElementById('countdown-minutes').textContent = minutes.toString().padStart(2, '0');
    document.getElementById('countdown-seconds').textContent = seconds.toString().padStart(2, '0');
  }
  
  // Update countdown every second
  updateCountdown();
  setInterval(updateCountdown, 1000);
});
